
import { NodeConfig } from './NodeConfig';

export class NodeConfigFactory {

    public static readonly Types = {
        Town: 'town',
        Crop: 'crop',
        Farm: 'farm',
        Granary: 'granary',
        Forest: 'forest',
        Meadows: 'meadows',
        Mountain: 'mountain',
        Castle: 'castle',
        Hut: 'hut',
        Temple: 'temple',
        Tower: 'tower',
    };

    public static createConfig(config: any): NodeConfig {
        if (!('type' in config)) config.type = NodeConfigFactory.Types.Town;
        if (!('spriteFrame' in config)) config.spriteFrame = NodeConfigFactory.defaultConfigs(config.type).spriteFrame;
        if (!('generationSpeed' in config)) config.generationSpeed = NodeConfigFactory.defaultConfigs(config.type).generationSpeed;
        if (!('defensivePower' in config)) config.defensivePower = NodeConfigFactory.defaultConfigs(config.type).defensivePower;
        if (!('initPopulation' in config)) config.initPopulation = NodeConfigFactory.defaultConfigs(config.type).initPopulation;
        if (!('maxPopulation' in config)) config.maxPopulation = NodeConfigFactory.defaultConfigs(config.type).maxPopulation;
        if (!('populationSupply' in config)) config.populationSupply = NodeConfigFactory.defaultConfigs(config.type).populationSupply;
        if (!('scoreStore' in config)) config.scoreStore = NodeConfigFactory.defaultConfigs(config.type).scoreStore;
        if (!('scoreLossFactor' in config)) config.scoreLossFactor = NodeConfigFactory.defaultConfigs(config.type).scoreLossFactor;
        return config;
    }

    private static defaultConfigs(type: string): NodeConfig {
        const configs = [
            { type: NodeConfigFactory.Types.Town, generationSpeed: 0.5, defensivePower: 1, initPopulation: 1, maxPopulation: 30, populationSupply: 10, scoreStore: 30, scoreLossFactor: 0.2, spriteFrame: 13 },
            { type: NodeConfigFactory.Types.Hut, generationSpeed: 0.5, defensivePower: 1, initPopulation: 1, maxPopulation: 20, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 14 },
            { type: NodeConfigFactory.Types.Crop, generationSpeed: 1, defensivePower: 0.5, initPopulation: 1, maxPopulation: 30, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 3 },
            { type: NodeConfigFactory.Types.Farm, generationSpeed: 2, defensivePower: 0.25, initPopulation: 1, maxPopulation: 30, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 18 },
            { type: NodeConfigFactory.Types.Granary, generationSpeed: 0, defensivePower: 0.5, initPopulation: 1, maxPopulation: 30, populationSupply: 20, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 7 },
            { type: NodeConfigFactory.Types.Forest, generationSpeed: 0, defensivePower: 1.5, initPopulation: 1, maxPopulation: 0, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 6 },
            { type: NodeConfigFactory.Types.Meadows, generationSpeed: 0, defensivePower: 1, initPopulation: 1, maxPopulation: 0, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 8 },
            { type: NodeConfigFactory.Types.Mountain, generationSpeed: 0, defensivePower: 2, initPopulation: 1, maxPopulation: 0, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 10 },
            { type: NodeConfigFactory.Types.Castle, generationSpeed: 1, defensivePower: 2.5, initPopulation: 1, maxPopulation: 30, populationSupply: 10, scoreStore: 30, scoreLossFactor: 0.4, spriteFrame: 2 },
            { type: NodeConfigFactory.Types.Temple, generationSpeed: 1, defensivePower: 1, initPopulation: 1, maxPopulation: 0, populationSupply: 0, scoreStore: 100, scoreLossFactor: 2, spriteFrame: 15 },
            { type: NodeConfigFactory.Types.Tower, generationSpeed: 0, defensivePower: 2.5, initPopulation: 1, maxPopulation: 0, populationSupply: 0, scoreStore: 0, scoreLossFactor: 0, spriteFrame: 17 },
        ];

        const defaultConfig = configs.find((config: NodeConfig) => config.type === type);

        if (!defaultConfig) {
            throw new Error(`Node Type ${type} config not found and not init is possible`);
        }

        return defaultConfig;
    }
}
